<template>
  <ul class="uranai-videoletter-lp__theme__ul">
    <li class="uranai-videoletter-lp__theme__li" v-for="item in movieList" :key="item.planning_id">
        <a class="" :href="`/movie/custom/${item.planning_id}`">
          <img :src="`/static/img/lp/movie_plannings/video_theme_${item.planning_id}.png`" :alt="`${item.item_name}`">
          <div class="textarea">
            <p class="description">{{item.easy_explanation}}</p>
            <p class="price">¥{{item.price_taxin}}<span class="tax">(税込)</span></p>
          </div>
        </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: 'videoletter-list',
  data() {
    return {
      movieList: []
    }
  },
  mounted(){
    const planning_id = [4,1]
    axios.post('/api/items/getplan', {plan_id: planning_id}).then(res => {
      this.movieList = res.data.data_list
    })
  }
}
</script>

<style lang="scss" scoped>
  a {
    text-decoration: none;
    width: 100%;
    height: 100%;
  }

  .uranai-videoletter-lp__theme {
    min-width: 320px;
    max-width: 359px;
    display: flex;
    flex-direction: column;
    align-items: center;
    color: #676767;
    margin: 0 auto;

    &__ul {
      padding: 0;
      list-style-type: none;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
      align-items: center;
      @media screen and (max-width: 374px) {
        width: calc(100% - 16px);
      }
    }

    &__li {
      width: calc(50% - 3.5px);
      //margin-bottom: 8px;
      border-radius: 5px;
      background: white;
      position: relative;
      img {
        width: 100%;
        height: auto;
        display: block;
        @media screen and (max-width: 374px) {
          width: 100%;
          height: auto;
        }
      }

    }

    .textarea {
      font-family: "Hiragino Kaku Gothic Pro", Meiryo;
      padding: 12px 8px 8px;
      height: 110px;
      position: relative;
    }

    .description {
      font-size: 12px;
      text-align: left;
      line-height: 15px;
      color: #676767;
      @media screen and (max-width: 374px) {
        font-size: 11px;
      }
    }

    .price {
      text-align: right;
      font-size: 22px;
      font-weight: bold;
      color: black;
      line-height: 26px;
      height: 26px;
      font-family: din-2014, sans-serif;
      font-style: normal;
      font-weight: 700;
      position: absolute;
      bottom: 8px;
      right: 8px;
    }

    .tax {
      font-size: 10px;
      font-family: "Hiragino Kaku Gothic Pro", Meiryo;
    }
  }

</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/VideoletterList.vue